import DefaultLayout from '##/Default';
import List from './List';
import Form from './Form';
import UnitTypes from '../unit-types/UnitTypes';

const routes = [
    {
        path: '/properties',
        exact: true,
        layout: DefaultLayout,
        component: List,
        title: 'Properties',
        auth: true
    },
    {
        path: '/properties/create',
        exact: true,
        layout: DefaultLayout,
        component: Form,
        title: 'Add a new property',
        auth: true
    },
    {
        path: '/unit-types',
        exact: true,
        layout: DefaultLayout,
        component: UnitTypes,
        title: 'Specials',
        auth: true
    }

];

export default routes;
